import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../auth.service';
import { AuthActionDialogComponent } from '../../shared/auth/auth-action-dialog.component';
import { LoginModalComponent } from '../../shared/auth/login-modal.component';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthActionService {
  constructor(private dialog: MatDialog, private auth: AuthService, private router: Router) {}

  async ensureLoggedIn(): Promise<boolean> {
    if (this.auth.isLoggedIn()) return true;

    const pickRef = this.dialog.open(AuthActionDialogComponent, {
      width: '420px',
      data: {
        emails: (() => {
          const saved = this.auth.getSavedSessionEmails();
          if (saved.length) return saved;
          return this.auth.getRecentLoginEmails();
        })(),
      },
      autoFocus: false,
      disableClose: false,
    });

    const pickResult = await firstValueFrom(pickRef.afterClosed());
    if (!pickResult?.proceed) return false;

    if (pickResult.email) {
      const activated = await this.auth.activateSavedSession(pickResult.email);
      if (activated) {
        return true;
      }
    }

    const loginRef = this.dialog.open(LoginModalComponent, {
      width: '420px',
      data: { email: pickResult.email || '' },
      autoFocus: true,
      disableClose: false,
    });

    const loginResult = await firstValueFrom(loginRef.afterClosed());
    if (loginResult && typeof loginResult === 'object' && loginResult.navigateTo) {
      await this.router.navigate([loginResult.navigateTo]);
      return false;
    }
    return !!loginResult;
  }
}
